export const init = () => {
    const observer = new MutationObserver(() => {
        if (document.querySelector('.b-media-container')) {
            const box = document.querySelectorAll('.b-media-container:not([data-js-initialized])');
            box.forEach((item) => {
                item.dataset.jsInitialized = true;
                const buttons = item.querySelectorAll('.js-top-action-button');
                const contents = item.querySelectorAll('.js-content');
                buttons.forEach((button) => {
                    button.addEventListener('click', () => {
                        buttons.forEach(item => item.classList.remove('active'));
                        button.classList.add('active');
                        item.querySelector('.b-media-container__bottom-actions').classList.remove('active');
                        try {
                            item.querySelector('.b-media-container__image-zoom').removeAttribute('style');
                        }
                        catch (e) {
                            console.log('exception was thrown: ' + e);
                        }
                        contents.forEach((content) => {
                            content.classList.remove('active');
                            if (button.dataset.id === content.dataset.id){
                                content.classList.add('active');
                            }
                            if (item.querySelector('.b-media-container__bottom-actions') && content.classList.contains('active') && content.dataset.id === 'model') {
                                item.querySelector('.b-media-container__bottom-actions').classList.add('active');
                                try{
                                    item.querySelector('.b-media-container__image-zoom').style.display = 'none';
                                }
                                catch (e) {
                                    console.log('exception was thrown: ' + e);
                                }
                            } 
                        });  
                    });
                });
                if (item.querySelector('.js-fullscreen-model')) {
                    const fullscreenButton = item.querySelector('.js-fullscreen-model');
                    const tooltip = fullscreenButton.querySelector('.action__tooltip');
                    let focusedTooltip = false;
                    fullscreenButton.addEventListener('mouseenter', () => {
                        if (!document.body.lastElementChild.classList.contains('active-tooltip')){
                            const clone = tooltip.cloneNode(true);
                            document.body.appendChild(clone);
                            const positionRight = window.innerWidth - (getOffset(fullscreenButton).left + 9);
                            clone.style.position = 'fixed';
                            clone.style.zIndex = 9999;
                            clone.style.top = getOffset(fullscreenButton).top - clone.clientHeight - 5 + 'px';
                            if (positionRight <= clone.clientWidth) {
                                clone.style.right = 10 + 'px';
                            }
                            else {
                                clone.style.left = getOffset(fullscreenButton).left + 9 + 'px';
                            }
                            clone.classList.add('active-tooltip');
                        }
                    });
                    fullscreenButton.addEventListener('mouseleave', () => {
                        if (document.body.lastElementChild.classList.contains('active-tooltip')) {
                            const activeTooltip = document.body.lastElementChild;
                            activeTooltip.addEventListener('mouseenter', () => {
                                focusedTooltip = true;
                            });
                            activeTooltip.addEventListener('mouseleave', () => {
                                focusedTooltip = false;
                                activeTooltip.classList.remove('active-tooltip');
                                setTimeout(()=>{
                                    activeTooltip.remove();
                                },300)
                            });
                            setTimeout(()=>{
                                if (!focusedTooltip) {
                                    activeTooltip.classList.remove('active-tooltip');
                                    activeTooltip.remove();
                                }
                            },1)
                        }
                    });
                }
            });
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    function getOffset(element) {
        const rect = element.getBoundingClientRect();
        return {
          left: rect.left,
          top: rect.top
        };
    };
};